// extracted by mini-css-extract-plugin
export default {"wrapper":"Metrics_wrapper__TIQMw","head":"Metrics_head__kM6Vn","loader":"Metrics_loader__TpL78","tables":"Metrics_tables__G728U"};